module.exports = "/images/shopping-cart.svg";